module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Ga-Ha-Ib-Jb.525966fd.png";